<div class="menuitems__wrapper">
    <nav class="navbar-dark">
        <ul class="navbar-nav flex-column">

            <li class="nav-item open" routerLinkActive="open--selected" [routerLinkActiveOptions]="{exact: true}">
                <a class="nav-link"
                [routerLink]="['/clients']"
                role="button"
                (click)="t.close()"
                data-container="body"
                placement="right"
                ngbTooltip="{{ sidebarCollapsed ? 'Kunder' : '' }}"
                #t="ngbTooltip"
                aria-haspopup="true"
                aria-expanded="false">
                    <i class="fa fa-address-book" aria-hidden="true"></i>
                    <span [ngClass]="sidebarCollapsed ? 'menuitems__name--collapsed' : 'menuitems__name--normal'"> Kunder</span>
                </a>
            </li>

            <ng-container *ngIf="currentClient">

                <li *ngIf="currentClient?.kid > -1" class="nav-item open" routerLinkActive="open--selected">
                    <ng-template #tipContent>
                        {{currentClient?.glkundenr}}<br>
                        {{currentClient?.navn1}}<br>
                        {{currentClient?.navn2}}
                    </ng-template>
                    <a class="nav-link"
                    aria-haspopup="true"
                    aria-expanded="false"
                    [routerLink]="['/clients/' + currentClient?.kid]"
                    placement="right"
                    [ngbTooltip]="sidebarCollapsed ? tipContent : ''"
                    data-container="body"
                    #t="ngbTooltip">
                        <i class="fa fa-address-card" aria-hidden="true"></i>
                        <span [ngClass]="sidebarCollapsed ? 'menuitems__name--collapsed' : 'menuitems__name--normal'">{{currentClient?.glkundenr}}</span>
                        <div [ngClass]="sidebarCollapsed ? 'menuitems__name--collapsed' : 'menuitems__name--normal'">
                            <span class="menuitems__name--client-name">{{currentClient?.navn1}}</span>
                            <span class="menuitems__name--client-name">{{currentClient?.navn2}}</span>
                        </div>
                    </a>
                </li>

                <li *ngIf="currentClient?.kid > -1 && hasLegacy" class="nav-item popup">
                    <a class="nav-link"
                    (click)="t.close(); onOpenStamarkiv(currentClient)"
                    data-container="body"
                    placement="right"
                    ngbTooltip="{{ sidebarCollapsed ? 'Stamarkiv' : '' }}"
                    #t="ngbTooltip"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false">
                            <i class="fa fa-archive" aria-hidden="true"></i>
                            <span [ngClass]="sidebarCollapsed ? 'menuitems__name--collapsed' : 'menuitems__name--normal'">Stamarkiv</span>
                    </a>
                </li>

                <li *ngIf="currentClient?.kid > -1 && hasLegacy" class="nav-item popup">
                    <a class="nav-link"
                    (click)="t.close(); onOpenSkilleblade()"
                    data-container="body"
                    placement="right"
                    ngbTooltip="{{ sidebarCollapsed ? 'Skilleblade' : '' }}"
                    #t="ngbTooltip"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false">
                            <i class="fa fa-files-o" aria-hidden="true"></i>
                            <span [ngClass]="sidebarCollapsed ? 'menuitems__name--collapsed' : 'menuitems__name--normal'">Skilleblade</span>
                    </a>
                </li>

                <li *ngIf="currentClient?.kid > -1" class="nav-item">
                    <a class="nav-link" alt="Sager"
                    placement="right"
                    ngbTooltip="{{ sidebarCollapsed ? 'Sager' : '' }}"
                    data-container="body"
                    #t="ngbTooltip"
                    aria-haspopup="true"
                    aria-expanded="false"
                    [routerLink]="currentClient?.migreretTilNy469 ? ['/clients/' + currentClient?.kid] + '/regnskabsaar/latest' : ['/clients/' + currentClient?.kid] + '/sagsstyring'">
                        <i class="fa fa-folder-open" aria-hidden="true"></i>
                        <span [ngClass]="sidebarCollapsed ? 'menuitems__name--collapsed' : 'menuitems__name--normal'">Sager</span>
                    </a>
                    <app-clientcases
                        [sager]="clientCases"
                        [sidebarCollapsed]="sidebarCollapsed"
                        (openClientCase)="onOpenClientCase($event)"
                    ></app-clientcases>
                </li>
            </ng-container>

            </ul>
    </nav>
</div>

<div>
    <div [ngClass]="sidebarCollapsed ? 'userinfo--collapsed' : 'userinfo--normal'">
        Du er logget ind som<br>
        {{ currentUser?.fullname }}<br>
        {{ officeName }}
    </div>

    <div class="toggler__div" (click)="onToggleSidebar()">
        <i class="fa fa-angle-double-left"
            [@collapseButtonState]="!sidebarCollapsed ? 'default' : 'collapsed'">
        </i>
    </div>
</div>
